import dynamic from 'next/dynamic';

export { default as Button } from './Button';
export { default as Card } from './Card';
export { default as CardHeader } from './CardHeader';
export { default as CardLoading } from './CardLoading';
export { default as Container } from './Container';
export { default as DelModal } from './DelModal';
export { default as Divider } from './Divider';
export { default as DropInput } from './DropInput';
export { default as ExtLink } from './ExtLink';
export { default as Link } from './Link';
export { default as Loading } from './Loading';
export { default as Modal } from './Modal';
export { default as ToastHint } from './ToastHint';
export { default as withRouteGuard } from './withRouteGuard';

export const Slider = dynamic(import('./Slider'), {
  ssr: false,
});
